import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraDataTable } from '@mono/ui-components/captains';
import { Testids } from '@mono/ui-selectors';
export function TiersTab({ configs, onNavigate }) {
    return /*#__PURE__*/ _jsx(SpecraDataTable, {
        "data-testid": Testids.pricingWorkspace.tiersTable,
        rows: configs,
        rowKey: (tier)=>tier.id,
        getRowLabel: (tier)=>tier.tierLabel,
        onRowClick: (tier)=>onNavigate(`tiers/${tier.id}`),
        columns: [
            {
                id: 'label',
                header: 'Shared tier',
                cell: (tier)=>tier.tierLabel
            },
            {
                id: 'roles',
                header: 'Roles',
                cell: (tier)=>tier.group.lines.length
            },
            {
                id: 'ftes',
                header: 'FTEs',
                cell: (tier)=>tier.group.lines.reduce((sum, line)=>sum + (line.fteCount ?? 0), 0)
            }
        ]
    });
}
